import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  FadeIn,
  Grid,
  Button,
  Link,
  CenterContent,
} from 'components';
import ArtworkThumbnail from './ArtworkThumbnail';

const ArtworkGrid = ({
  artworks = [],
  status,
  limit = 24,
  small = false,
  message,
  showInfo = true,
  showTitles = false,
  showLikes = true,
  showDislikes = false,
  showSaves = true,
  showPrices = true,
  showDetails = true,
  showArtists = false,
  magnify = true,
  columns = false,
  center = false,
}) => {
  const { location } = useSelector((store) => store);
  const fakeGrid = Array(limit).fill(0);
  const back_url = location.pathname;
  const back_title = location.pathname.replace('/', '') || 'artworks';

  // const minmax = false
  // const minmax = small ? '180px, 1fr' : '280px, 1fr'
  const minmax = small ? '160px, 180px' : '300px, 1fr';
  const minmaxMobile = '160px, 1fr';
  const gap = '2px';
  const mobileGap = '1em';
  const rowGap = '1em';
  const cols = false; //Array(artworks.length).fill(0).map(i=>'1fr').join(' ')

  const centered = {
    display: 'flex',
    justifyContent: 'center',
  };

  const style = {
    rowGap: rowGap,
    ...(center ? centered : {}),
  };

  const states = {
    Pending: (
      <Grid
        columns={cols}
        minmax={minmax}
        minmaxMobile={minmaxMobile}
        gap={gap}
        mobileGap={mobileGap}
        style={style}
      >
        {fakeGrid.map((artwork, i) => (
          <ArtworkThumbnail fake key={i} />
        ))}
      </Grid>
    ),
    Success: artworks.length ? (
      <Grid
        columns={cols}
        minmax={minmax}
        minmaxMobile={minmaxMobile}
        gap={gap}
        mobileGap={mobileGap}
        style={style}
      >
        {artworks.slice(0, limit).map((artwork) => (
          <ArtworkThumbnail
            key={artwork.id}
            data={artwork}
            showInfo={showInfo}
            showTitle={showTitles}
            showLike={showLikes}
            showDislike={showDislikes}
            showSave={showSaves}
            showPrice={showPrices}
            showDetail={showDetails}
            showArtist={showArtists}
            magnify={magnify}
            small={small}
          />
        ))}
      </Grid>
    ) : (
      <CenterContent>
        <h2>{message || 'No artworks for this search'}</h2>
        <Link to={back_url}>
          <Button small outlined tabIndex="-1">
            Back to {back_title}
          </Button>
        </Link>
      </CenterContent>
    ),
    Error: (
      <CenterContent>
        <h2>Artworks did not load :O</h2>
        <Link to={back_url}>
          <Button small outlined tabIndex="-1">
            Back to {back_title}
          </Button>
        </Link>
      </CenterContent>
    ),
  };

  return states[status] ? states[status] : states['Pending'];
};

export default ArtworkGrid;
